export default __webpack_public_path__ + "static/media/wPants_1.ae3272c5.bin";